import { render, staticRenderFns } from "./channelList.vue?vue&type=template&id=0aebdde2&scoped=true&"
import script from "./channelList.vue?vue&type=script&lang=js&"
export * from "./channelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aebdde2",
  null
  
)

export default component.exports